import { render, staticRenderFns } from "./coop-top-panel.vue?vue&type=template&id=5dc26c92"
import script from "./coop-top-panel.vue?vue&type=script&lang=js"
export * from "./coop-top-panel.vue?vue&type=script&lang=js"
import style0 from "./coop-top-panel.vue?vue&type=style&index=0&id=5dc26c92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports